import React from "react";
import AccordionWrapper from "../../elements/accordion-wrapper";
import BodyText from "../../elements/body-text";
const QAAccordionList = ({ items }) => {
  return (
    <div className="accordion-container">
      {items.map(item => {
        const { headingType, headingBody, body, isExpanded } = item.fields;
        const accordionProps = {
          heading: {
            type: headingType,
            html: headingBody
          },
          open: isExpanded.value
        };
        return (
          <AccordionWrapper {...accordionProps} key={item.id}>
            <div className="booking-content">{items && <BodyText html={body} className="book-description" />}</div>
          </AccordionWrapper>
        );
      })}
    </div>
  );
};
export default QAAccordionList;
